// Format text when a field loses focus, before its form is saved.
const upperFields = /codice\s*fiscale|codicefiscale|\biban\b|\btarga\b|partita\s*iva|partitaiva|\bprovincia\b|\bpr\.?\b/i;
const untouchedFields = /e-?mail|\bmail\b|telefono|cellulare|\bfax\b|\bcap\b|numero\s*(sinistro|polizza|progressivo)|\bpec\b|\burl\b|\bsito\b|password|ricerca|cerca/i;

export function titleCase(value) {
  return String(value || '').toLocaleLowerCase('it-IT').replace(/(^|[\s'’-])([\p{L}])/gu,
    (_match, separator, letter) => separator + letter.toLocaleUpperCase('it-IT'));
}

export function sentenceCase(value) {
  return String(value || '').toLocaleLowerCase('it-IT').replace(/(^|\.\s*)([\p{L}])/gu,
    (_match, prefix, letter) => prefix + letter.toLocaleUpperCase('it-IT'));
}

export function autoFormatOnBlur(event) {
  const field = event.target;
  if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement)) return;
  if (field instanceof HTMLInputElement && field.type !== 'text') return;
  if (field.dataset.noAutoformat === 'true' || field.readOnly || field.disabled) return;
  const label = field.labels ? [...field.labels].map(item => item.textContent).join(' ') : '';
  const hint = [field.name, field.id, field.placeholder, field.getAttribute('aria-label'), label].filter(Boolean).join(' ');
  const current = field.value;
  if (!current.trim()) return;
  const formatted = field.dataset.autoformat === 'sentence' ? sentenceCase(current) :
    upperFields.test(hint) ? current.toLocaleUpperCase('it-IT') :
    untouchedFields.test(hint) ? current : titleCase(current);
  if (formatted === current) return;
  const prototype = field instanceof HTMLTextAreaElement ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
  Object.getOwnPropertyDescriptor(prototype, 'value').set.call(field, formatted);
  field.dispatchEvent(new Event('input', { bubbles: true }));
}
